/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { useModal } from "../../../context/ModalContext";
import { CloseIcon, PaymentOverdueIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { useNavigate } from "react-router-dom";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { userActivityLogger } from "../../../utils/mixpanel";
import { PAGES_PATH } from "../../../navigation/params";


const WellnessPlanPaymentErrorModal = () => {
  const { closeModal, source: failedInvoiceLink,
    params: { petName, petId, species, wellnessPlanCode } } = useModal();
  const navigate = useNavigate();

  const modalType = {
    paymentIssue: {
      title: "Issue with Payment",
      description: <div>
        <p>Something went wrong with your initial payment for {petName}&apos;s plan.
          If we do not receive payment in the next 3 days we will cancel your plan.</p>
      </div>,
      cta: "Pay Invoice",
    },
    paymentPending: {
      title: "Payment Pending",
      description: <p>Your payment is currently
        pending. Check back soon for updates on your subscription.</p>,
      cta: "Got it",
    },
  };

  const modalData = failedInvoiceLink ? modalType.paymentIssue : modalType.paymentPending;

  const handleCta = () => {
    if (failedInvoiceLink) {
      userActivityLogger(MIXPANEL_EVENTS.PAYMENT_ISSUE_PAY_INVOICE_CLICKED, {
        pet_name: petName,
        pet_id: petId,
        species: species,
        wellness_plan_code: wellnessPlanCode,
      });
      window.open(failedInvoiceLink, "_blank");

      return;
    }
    userActivityLogger(MIXPANEL_EVENTS.PAYMENT_PENDING_GOT_IT_CLICKED, {
      pet_name: petName,
      pet_id: petId,
      species: species,
      wellness_plan_code: wellnessPlanCode,
    });
    handleModalClose("ctaClick");
  };

  const handleModalClose =(source?: "ctaClick") =>{
    if (source !== "ctaClick") {
      if (failedInvoiceLink) {
        userActivityLogger(MIXPANEL_EVENTS.PAYMENT_ISSUE_PAY_INVOICE_MODAL_DISMISSED, {
          pet_name: petName,
          pet_id: petId,
          species: species,
          wellness_plan_code: wellnessPlanCode,
        });
      } else {
        userActivityLogger(MIXPANEL_EVENTS.PAYMENT_PENDING_MODAL_DISMISSED, {
          pet_name: petName,
          pet_id: petId,
          species: species,
          wellness_plan_code: wellnessPlanCode,
        });
      }
    }
    closeModal();
    navigate(PAGES_PATH.PET_CARE + `?id=${petId}&category=TotalCare_Plan`);
  };

  return (
    <>
      <div className="flex flex-col w-full xl:w-[22rem]">
        <div className="flex justify-end">
          <CloseIcon
            onClick={handleModalClose}
            className="text-light-black cursor-pointer"
          />
        </div>
        <div className="w-full flex flex-col items-center gap-3">
          <div>
            <PaymentOverdueIcon width={72} height={72} />
          </div>
          <div className="text-xl font-semibold text-center w-80">
            {modalData.title}
          </div>
          <div className="flex flex-col w-full">
            <div className="flex justify-center mb-4">
              <div className="text-center">
                {modalData.description}
              </div>
            </div>
            <StyledBookingFlowButton
              disabled={false}
              fullWidth
              color="primary"
              className="!text-sm"
              size="small"
              onClick={handleCta}
            >
              {modalData.cta}
            </StyledBookingFlowButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default WellnessPlanPaymentErrorModal;
